import { inject } from "@angular/core";
import { ActivatedRoute, CanDeactivateFn } from "@angular/router";
import { AlertService } from "@malirang/front-share";
import FixDocumentFormPage from "./fix-document-form";

const handleAlert = (): Promise<Boolean> => {
    return new Promise((resolve, reject) => {
        const alertService = inject(AlertService);

        alertService
            .open({
                title: "저장되지 않은 변경사항",
                content: `저장하지 않은 변경사항이 있습니다.
        작성중인 문서를 저장하시겠습니까?`,
                type: "info",
                buttons: {
                    confirm: {
                        text: "저장",
                    },
                },
            })
            .closed.subscribe({
                next: (res) => {
                    resolve(res?.action === "confirm");
                },
            });
    });
};

/**
 * 변경사항을 저장하지 않았을 경우 저장 여부를 묻는 가드
 * @param component
 * @returns
 */
export const fixDocumentFormGuard: CanDeactivateFn<
    FixDocumentFormPage
> = async (component: FixDocumentFormPage) => {
    const route = inject(ActivatedRoute);
    const documentId = route.snapshot.queryParams["documentId"];

    // isDirty 체크 추가: 실제로 변경사항이 있고, 완료되지 않았을 때만 경고
    if (component?.isDirty && component.isDirty() && !component?.complete()) {
        const res = await handleAlert();

        if (res) {
            component.handleSubmit();
        }
    }

    return true;
};
